import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/receita/tarjaNova.png'
import _imports_1 from '../assets/receita/EMPRESA.png'
import _imports_2 from '../assets/receita/celulares.png'
import _imports_3 from '../assets/receita/apple.png'
import _imports_4 from '../assets/receita/google.png'
import _imports_5 from '../assets/receita/LogoVoltyEmpresaCor.png'
import _imports_6 from '../assets/home/logo_branco.svg'
import _imports_7 from '../assets/home/linkedin_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-93fb9c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  style: {"-moz-transform":"scaleX(-1)","-o-transform":"scaleX(-1)","-webkit-transform":"scaleX(-1)","transform":"scaleX(-1)"},
  src: _imports_0,
  alt: "Tarja"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "header",
  class: "flex column"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logo",
    src: _imports_1,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { id: "slogan" }, [
    /*#__PURE__*/_createTextVNode("Aplicativo Mobile para Consulta de"),
    /*#__PURE__*/_createElementVNode("span", { class: "slogan_Orange" }, " Dados"),
    /*#__PURE__*/_createTextVNode(" de"),
    /*#__PURE__*/_createElementVNode("span", { class: "slogan_Orange" }, " Pessoa Jurídica")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  src: _imports_0,
  alt: "Tarja"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex flex-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "celulares",
    src: _imports_2,
    alt: "Laptop"
  })
], -1))
const _hoisted_5 = {
  id: "info",
  class: "flex column"
}
const _hoisted_6 = { class: "flex flex-center q-mt-xl q-mb-md q-gutter-md" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"line-height":"34px"},
  class: "flex column text-white q-ml-md"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"26px"} }, "baixe na"),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"40px"} }, "App Store")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"line-height":"34px"},
  class: "flex column text-white q-ml-md"
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"26px"} }, "baixe na"),
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold","font-size":"40px"} }, "Google Play")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-mt-md" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("p", { id: "text" }, "O aplicativo Volty Empresa proporciona uma maneira fácil de consultar dados de pessoas jurídicas na base de dados pública do Governo Federal Brasileiro. O sistema permite a obtenção de informações da empresa procurada, tais como a situação da empresa, atividades econômicas, endereços e contatos. Há ainda a visualização do grafo societário de forma interativa, com a possibilidade de cruzamento de dados com sócios, associados e filiais, além da função de exportar os dados obtidos para CSV, JSON e PDF."),
  /*#__PURE__*/_createElementVNode("p", { id: "text_disponivel" }, "Disponível para iOS e Android.")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tarja",
  style: {"-moz-transform":"scaleX(-1)","-o-transform":"scaleX(-1)","-webkit-transform":"scaleX(-1)","transform":"scaleX(-1)"},
  src: _imports_0,
  alt: "Tarja"
}, null, -1))
const _hoisted_11 = {
  id: "footer",
  class: "column flex items-center"
}
const _hoisted_12 = {
  id: "rodape",
  class: "row flex items-center"
}
const _hoisted_13 = { class: "divfoot row flex items-end" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"128px"},
  src: _imports_6,
  alt: "Logo"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  id: "email",
  style: {"color":"white"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bolder"} }, "E-mail"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("contato@studioapp.com.br")
], -1))
const _hoisted_17 = { class: "divfoot2 column flex" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"end","margin-bottom":"40px"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.linkedin.com/company/studioapp/",
    target: "_blank"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"36px","height":"36px","color":"white"},
      src: _imports_7,
      alt: "Linkedin"
    })
  ])
], -1))
const _hoisted_19 = { class: "flex items-center column" }
const _hoisted_20 = { style: {"color":"white"} }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  id: "ad",
  style: {"text-decoration":"none","align-self":"end","margin-right":"3%"},
  href: "https://www.amaiscriacao.com.br/",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row flex" }, [
    /*#__PURE__*/_createElementVNode("p", { style: {"color":"white","margin-right":"5px","font-size":"10px"} }, "Designed by"),
    /*#__PURE__*/_createElementVNode("img", {
      style: {"width":"20px","height":"12px"},
      src: "https://static.wixstatic.com/media/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.png/v1/fill/w_79,h_46,al_c,q_85,usm_0.66_1.00_0.01/dea8ea_9a6a9b63390345b8a17dfd74e3f4ab09.webp"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    id: "body",
    class: "column no-wrap"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_q_card, {
            style: {"width":"350px"},
            id: "cardApp",
            class: "flex justify-center",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('https://apps.apple.com/br/app/volty-empresa/id6475312297')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "flex row no-wrap" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_img, {
                    width: "64px",
                    height: "64",
                    src: _imports_3
                  }),
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card, {
            style: {"width":"350px"},
            id: "cardApp",
            class: "flex justify-center",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('https://play.google.com/store/apps/details?id=br.com.studioapp.receita_federal')))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "flex row no-wrap" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_img, {
                    width: "64px",
                    height: "64",
                    src: _imports_4
                  }),
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_9
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/'))),
              style: {"cursor":"pointer"}
            }, _hoisted_15),
            _hoisted_16
          ]),
          _createVNode(_component_q_space),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("p", _hoisted_20, "© studioApp - " + _toDisplayString(new Date().getFullYear()) + " | Todos os direitos reservados", 1)
            ])
          ])
        ]),
        _hoisted_21
      ])
    ]),
    _: 1
  }))
}